import React, { useState } from 'react'
import styled from 'styled-components'
import Form from '../components/Form'

const Main = styled.div`
	min-height: 100vh;
	color: #888;
	max-width: 1400px;
  margin: 0 auto;

	h1 {
  	margin: 32px 16px 8px 16px;
    font-size: 2em;
	}

	p {
		margin: 0 16px 32px 16px;
		font-size: 1em;
		line-height: 1.4;
	}
`

const Error = styled.p`
  background-color: #000;
  color: #888;
  font-size: 1.25em;
  padding: 16px;
  border-radius: 4px;
  margin-left: 16px;
	display: inline-block;
	float: left;
`

const Container = styled.div`
	width: 100%;
	height: 450px;
	margin: 64px 0;
`

//These are the era-appropriate photo styles.
const BW = styled.div`
	max-width: 300px;
	height: 450px;
	margin: 0 auto;
	background: url(${props => props.image}) center center no-repeat;
	background-size: cover;
	border: 8px solid #FCFBEC;
	border-radius: 2px;
	filter: sepia(1) grayscale(.7);
	box-shadow: 0px 0px 8px rgba(0,0,0,.6);
`

const Yellow = styled.div`
	max-width: 300px;
	height: 450px;
	margin: 0 auto;
	background: url(${props => props.image}) center center no-repeat, #D3BF8B;
	background-size: cover;
	border-radius: 16px;
	background-blend-mode: darken;
	filter: contrast(.7);
	box-shadow: 0px 0px 8px rgba(0,0,0,.6);
`

const Polaroid = styled.div`
	max-width: 300px;
	height: 300px;
	margin: 0 auto;
	background: url(${props => props.image}) center center no-repeat;
	background-size: cover;
	border-right: 25px solid #fff;
	border-top: 25px solid #fff;
	border-left: 25px solid #fff;
	border-bottom: 85px solid #fff;
	border-radius: 2px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 1) inset, 0px 0px 8px rgba(0,0,0,.6);
	filter: saturate(.7);
`

const Now = styled.div`
	max-width: 300px;
	height: 450px;
	margin: 0 auto;
	background: url(${props => props.image}) center center no-repeat;
	background-size: cover;
	box-shadow: 0px 0px 8px rgba(0,0,0,.6);
`

const Null = styled.div`
	max-width: 300px;
	height: 450px;
`

//Sets which photo style to use.
const Photo = (props) => {
	if (props.era === 'bw') {
		return <BW image={ props.image }></BW>
	} else if (props.era === 'yellow') {
		return <Yellow image={ props.image }></Yellow>
	} else if (props.era === 'polaroid') {
		return <Polaroid image={ props.image }></Polaroid>
	} else if (props.era === 'now'){
		return <Now image={ props.image }></Now>
	} else {
		return <Null></Null>
	}
}

const Archive = (props) => {
	const [month, setMonth] = useState('January')
	const [year, setYear] = useState('2019')
	const [era, setEra] = useState('')
	const [archive, setArchive] = useState([''])

	const handleClick = e => {
    e.preventDefault()
		const notAvailable = 'http://i.annihil.us/u/prod/marvel/i/mg/b/40/image_not_available'

		const getEra = () => {
			if (year < 1960) {
				setEra('bw')
			} else if (year < 1980) {
				setEra('yellow')
			} else if (year < 2000) {
				setEra('polaroid')
			} else {
				setEra('now')
			}
		}

		const getArchive = data => {
			setArchive([])
			data.data.results.map(item => {
				if (item.thumbnail.path !== notAvailable) {
					const photo = item.thumbnail.path + '/portrait_uncanny.' + item.thumbnail.extension
					setArchive([photo])
				}
					return null
			})
		}

		//Marvel API: https://developer.marvel.com/
    const url = `https://gateway.marvel.com:443/v1/public/comics?dateRange=${year}-${month}-01%2C%20${year}-${month}-30&limit=5&apikey=541f922513aa3b4e06a535f280c5194b`
    fetch(url)
      .then(response => response.json())
      .then ((data) => {
				getEra()
				getArchive(data)

      })
      .catch(error => {
          console.log('it broke')
        })
  }

	const handleChange = (e) => {
		if (e.target.id === 'month') {
			setMonth(e.target.value)
		} else {
			setYear(e.target.value)
		}
	}

	return (
		<Main>
			<h1>The Archives</h1>
			<p>Search for documented historical incidents.</p>
			<Form
				type='selects'
				instructions='Select Dates'
				onChange={ handleChange }
				onClick = { handleClick }
			/>
			<Container>
				{(archive.length === 0)
					? <Error>No Records Found</Error>
					: <Photo era={ era } image={ archive[0] }/>
				}
			</Container>
		</Main>
	)
}

export default Archive
